import { TableSchema } from '../metadata-schema';
import { IndicatorCode } from '../enums/IndicatorCode';
import { dim_no_norm_onderwijsresultaat } from './dim_no_norm_onderwijsresultaat';
import { dim_ov_onderwijspositie_vergelijkgroep } from './dim_ov_onderwijspositie_vergelijkgroep';
import { dim_vs_vestiging } from './dim_vs_vestiging';
import { IndicatorNaam } from '../enums/IndicatorNaam';
import { Niveau } from '../enums/Niveau';

export const fac_or_onderwijsresultaten: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_or_onderwijsresultaten",
	"description": "Definitie voor fact tabel fac_or_onderwijsresultaten uit de CumLaude DWH.\nEen onderwijsresultaat uit het onderwijsresultatenmodel aan de hand waarvan de Onderwijsinspectie alle VO-scholen beoordeelt.\nIedere rij stelt één onderwijsresultaat voor: een score op één van de vier indicatoren over één schooljaar voor één vestiging en eventueel niveau (alleen Bovenbouwsucces/Examencijfers).\nIn de beoordeling van een bepaald peiljaar berekent de inspectie voor iedere indicator het gemiddelde van de onderwijsresultaten over de 3 voorafgaande schooljaren. Er wordt ook een gemiddelde berekend als van slechts twee schooljaren, waaronder het meest recente schooljaar, gegevens bekend zijn.",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.LandelijkOfInstelling"
	],
	"properties": {
		"or_co_brin": {
			"type": "string",
			"filter": false,
			"exportable": false,
			"grouping": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_co_brinvest": {
			"type": "string",
			"label": "Vestigingscode",
			"searchKeys": [
				"BRIN",
				"BRIN (vestiging)"
			],
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "01XX00",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het BRIN-nummer inclusief vestigingsvolgnummer van de vestiging waarop dit onderwijsresultaat betrekking heeft."
		},
		"or_co_indicator": {
			"filter": false,
			"exportable": false,
			"grouping": false,
			"blocklist": {
				"geenVO": true
			},
			"type": "string",
			"schema": IndicatorCode
		},
		"or_co_vestiging": {
			"type": "string",
			"filter": false,
			"exportable": false,
			"grouping": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_d_geldig_tot": {
			"type": "string",
			"format": "date",
			"filter": false,
			"exportable": false,
			"grouping": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_d_geldig_va": {
			"type": "string",
			"format": "date",
			"filter": false,
			"exportable": false,
			"grouping": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_fkd_no": {
			"description": "Definitie voor dimension tabel dim_no_norm_onderwijsresultaat uit de CumLaude DWH",
			"type": "object",
			"schema": dim_no_norm_onderwijsresultaat
		},
		"or_fkd_ov": {
			"description": "Definitie voor dimension tabel dim_ov_onderwijspositie_vergelijkgroep uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ov_onderwijspositie_vergelijkgroep
		},
		"or_fks_vs_bekostiging": {
			"type": "array",
			"items": {
				"include": [],
				"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
				"type": "object",
				"schema": dim_vs_vestiging
			}
		},
		"or_fun_des_bron": {
			"type": "string",
			"label": "Bron",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "Bronsysteem, Inspectie (2023)",
			"blocklist": {
				"geenVO": true
			},
			"description-somtoday": "Herkomst van de gegevens waarop dit onderwijsresultaat is gebaseerd:\n- Bronsysteem: dit onderwijsresultaat is door CumLaude berekend op basis van de gegevens in Somtoday.\n- Inspectie (peiljaar): dit onderwijsresultaat is door de Onderwijsinspectie berekend in het betreffende peiljaar op basis van de gegevens van DUO.",
			"description-magister": "Herkomst van de gegevens waarop dit onderwijsresultaat is gebaseerd:\n- Bronsysteem: dit onderwijsresultaat is door CumLaude berekend op basis van de gegevens in Magister.\n- Inspectie (peiljaar): dit onderwijsresultaat is door de Onderwijsinspectie berekend in het betreffende peiljaar op basis van de gegevens van DUO."
		},
		"or_fun_nr_peiljaar": {
			"type": "number",
			"label": "Peiljaar",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "2024",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het kalenderjaar waarvoor dit onderwijsresultaat meetelt.\nIn de beoordeling van een bepaald peiljaar berekent de inspectie voor iedere indicator het gemiddelde van de onderwijsresultaten over de 3 voorafgaande schooljaren. Voor coronajaren gelden hierop enkele uitzonderingen."
		},
		"or_fun_is_meetellend": {
			"type": "boolean",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_nm_bron": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_nm_indicator": {
			"label": "Indicator",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "onderwijspositie, onderbouwsnelheid, bovenbouwsucces, examencijfers",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het aspect binnen het onderwijsresultatenmodel waarop de score van dit onderwijsresultaat betrekking heeft:\n- onderwijspositie: de score is berekend door voor iedere leerling in leerjaar 3 het verschil te bepalen tussen het actuele niveau en \nhet basisschooladvies, waarbij een hoger niveau positief telt en een lager negatief, waarna dit verschil wordt uitgedrukt als percentage.\n- onderbouwsnelheid: de score is het percentage leerlingen in leerjaar 1 en 2 dat is doorgestroomd naar een hoger leerjaar (ongeacht niveau).\n- bovenbouwsucces: de score is het percentage leerlingen vanaf leerjaar 3 dat het schooljaar succesvol afrondt door te slagen, door te stromen\nnaar een hoger leerjaar van hetzelfde of hoger niveau, of naar hetzelfde leerjaar van een hoger niveau.\n- examencijfers: de score is het gemiddelde cijfer voor het centraal examen van alle vakken, inclusief beroepsgerichte vakken, van de geslaagde\nen gezakte leerlingen in het betreffende schooljaar.",
			"type": "string",
			"schema": IndicatorNaam
		},
		"or_nm_schooljaar": {
			"type": "string",
			"label": "Schooljaar",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "2022/2023",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het schooljaar waarover dit onderwijsresultaat is berekend:\n- Voor de indicator Onderbouwsnelheid en Bovenbouwsucces is dit het schooljaar die de leerlingen wel of niet succesvol afronden.\n- Voor de indicator Onderwijspositie is dit het schooljaar waarin de leerlingen in leerjaar 2 zitten voordat ze naar leerjaar 3 gaan. \nNB: de inspectie toont een schooljaar later.\n- Voor de indicator Examencijfers is dit het schooljaar waarin de leerlingen examen doen."
		},
		"or_nm_soort_onderwijs": {
			"label": "Niveau",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "VMBO b, VMBO k, VMBO (g)t, HAVO, HAVO / VWO, VWO",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het niveau waarop dit onderwijsresultaat betrekking heeft.\nDit is alleen van toepassing op de indicatoren Bovenbouwsucces en Examencijfers. Voor de indicatoren Onderwijspositie en Onderbouwsnelheid worden de scores niet uitgesplitst per niveau.",
			"type": "string",
			"schema": Niveau
		},
		"or_nm_vergelijkgroep": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_nr_jobrun": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_nr_peiljaar": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_nr_score": {
			"type": "number",
			"label": "Score totaal",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "456",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het door de vestiging gescoorde 1-jaarsgemiddelde voor deze indicator.\nVoor de indicatoren Onderwijspositie, Onderbouwsnelheid en Bovenbouwsucces is dit een percentage, voor de indicator Examencijfers is dit een gemiddeld cijfer.\nZie de beschrijving van het veld Indicator voor de berekening hiervan."
		},
		"or_nr_versie": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_nrs_cl_peiljaren": {
			"type": "array",
			"items": {
				"type": "number"
			},
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_pk_key": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"or_q_apcg": {
			"type": "integer",
			"label": "Aantal leerlingen APCG",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"searchKeys": [
				"Armoedeprobleemcumulatiegebied",
				"postcode"
			],
			"example": "12",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het aantal leerlingen waarop dit onderwijsresultaat betrekking heeft die woonachtig zijn in een postcode die is aangemerkt als Armoedeprobleemcumulatiegebied.\nVoor de indicatoren Onderbouwsnelheid, Bovenbouwsucces en Examencijfers wordt het percentage van deze leerlingen meegenomen in de correctie op de norm."
		},
		"or_q_instroom": {
			"type": "integer",
			"label": "Aantal leerlingen instroom",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "3",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het aantal leerlingen waarop dit onderwijsresultaat betrekking heeft die tussentijds zijn ingestroomd.\nDit betreft leerlingen uit leerjaar 2 en hoger die in het voorafgaande schooljaar stonden ingeschreven op een andere VO-instelling (BRIN4) of geen onderwijs volgden.\nVoor de indicatoren Onderbouwsnelheid, Bovenbouwsucces en Examencijfers wordt het percentage van deze leerlingen meegenomen in de correctie op de norm."
		},
		"or_q_leerlingen": {
			"type": "integer",
			"label": "Aantal leerlingen totaal",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "123",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het totaal aantal leerlingen waarop dit onderwijsresultaat betrekking heeft.\nVoor indicatoren Onderwijspositie, Onderbouwsnelheid en Bovenbouwsucces worden onderwijsresultaten over minder dan 20 leerlingen niet meegenomen."
		},
		"or_q_lwoo": {
			"type": "integer",
			"label": "Aantal leerlingen LWOO",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"searchKeys": [
				"Leerwegondersteund onderwijs"
			],
			"example": "2",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het aantal leerlingen waarop dit onderwijsresultaat betrekking heeft die leerwegondersteund onderwijs volgen.\nTot en met peiljaar 2019 werd het percentage van deze leerlingen meegenomen in de correctie op de norm voor de indicator Bovenbouwsucces van het VMBO."
		},
		"or_q_opstroom": {
			"type": "integer",
			"label": "Aantal leerlingen opstroom",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "3",
			"description": "Het aantal leerlingen waarop dit onderwijsresultaat betrekking heeft die na het behalen van hun VMBO (g)t- of HAVO-diploma zijn opgestroomd naar een hoger niveau.\nVoor de indicatoren Bovenbouwsucces en Examencijfers wordt het percentage van deze leerlingen meegenomen in de correctie op de norm."
		},
		"or_q_vakken": {
			"type": "integer",
			"label": "Aantal vakken (examencijfers)",
			"category": "Onderwijsresultaten",
			"filter": false,
			"grouping": false,
			"example": "1234",
			"blocklist": {
				"geenVO": true
			},
			"description": "Het totaal aantal vak/leerling-combinaties waarop dit onderwijsresultaat betrekking heeft. Ieder relevant vak van iedere leerling waarop hij of zij een SE- en/of CE-cijfer heeft behaald telt hierin mee.\nDit is alleen van toepassing op de indicator Examencijfers. Er wordt geen onderwijsresultaat berekend voor de indicator Examencijfers als dit aantal vak/leerling-combinaties kleiner is dan 30."
		}
	}
};
